import './AdPodPreviewSection.scss';

import React, { useMemo } from 'react';

import { PodPosition } from '../../../apis/graphql';
import bem from '../../../utils/bem';
import type { TransformedSequence } from '../types';
import { formatPodPositionTitle } from '../utils/adPodUtils';
import AdPodPreview from './AdPodPreview';

const [block, element] = bem('ad-pod-preview-section');

type AdPodPreviewSectionProps = {
  sequence: TransformedSequence;
  sequenceIndex: number;
};

const AdPodPreviewSection = ({ sequence, sequenceIndex }: AdPodPreviewSectionProps): JSX.Element => {
  const visiblePods: string[] = useMemo(() => {
    const podsInUse: string[] =
      (sequence.ads
        .map((ad) => ad?.adSequence?.podPosition)
        .filter(
          (podPosition) => podPosition && podPosition !== PodPosition.Preroll && podPosition !== PodPosition.Postroll
        ) as string[]).sort((a, b) => a.localeCompare(b)) || [];

    return [...new Set([PodPosition.Preroll, ...podsInUse, PodPosition.Postroll])];
  }, [sequence]);

  return (
    <div className={block()}>
      <h1>Ad Pod Preview</h1>

      <div className={element('ad-pod-preview-body')}>
        {visiblePods.map((pod) => {
          const podAds = sequence.ads.filter((ad) => ad.adSequence?.podPosition === pod);
          return (
            <AdPodPreview
              key={pod}
              title={formatPodPositionTitle(pod)}
              podPosition={pod}
              sequenceIndex={sequenceIndex}
              ads={podAds}
            />
          );
        })}
      </div>
    </div>
  );
};

export default AdPodPreviewSection;
